import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import ResourceCategoryForm from '../containers/ResourceCategoryFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class ResourceCategoryEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `ResourceCategoryEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('resource_category_route_edit')} />
          <ResourceCategoryForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default ResourceCategoryEditScreen;

Logger.log('silly', `ResourceCategoryEditScreen loaded.`);